import { CoreBox, CoreTypography } from '@youscience/core';
import { Skeleton } from '@mui/material';
import { StyledCardWrap } from './SchoolCard.styles';

import {
  sxStyles,
  StyledHeaderWrap,
  StyledProgressWrap,
  StyledInfoSection,
  StyledInfoItemsWrap,
} from './components/SchoolCardHeader/SchoolCardHeader.styles';

export const SchoolCardSkeleton = () => {
  return (
    <StyledCardWrap>
      <StyledHeaderWrap>
        <StyledInfoSection>
          <StyledProgressWrap>
            <Skeleton variant="circular" width={56} height={56} />

            <CoreTypography data-testid="progressCircleTitle" variant="caption">
              <Skeleton width={80} />
            </CoreTypography>
          </StyledProgressWrap>

          <CoreBox sx={sxStyles.schoolInfo}>
            <CoreTypography variant="h6" component="h5">
              <Skeleton width="10rem" height="2rem" />
            </CoreTypography>

            <StyledInfoItemsWrap>
              <Skeleton width="10rem" height="2rem" />
              <CoreBox sx={sxStyles.infoItemDivider} />

              <Skeleton width="10rem" height="2rem" />
              <CoreBox sx={sxStyles.infoItemDivider} />

              <Skeleton width="10rem" height="2rem" />
              <CoreBox sx={sxStyles.infoItemDivider} />
            </StyledInfoItemsWrap>
          </CoreBox>
        </StyledInfoSection>
      </StyledHeaderWrap>
    </StyledCardWrap>
  );
};
